import { render, staticRenderFns } from "./discountList.vue?vue&type=template&id=58e6a6b2&scoped=true"
import script from "./discountList.vue?vue&type=script&lang=js"
export * from "./discountList.vue?vue&type=script&lang=js"
import style0 from "./discountList.vue?vue&type=style&index=0&id=58e6a6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6a6b2",
  null
  
)

export default component.exports